"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const material_1 = require("@angular/material");
const _4d_mapper_1 = require("4d-mapper");
const router_1 = require("@angular/router");
const ngx_stripe_1 = require("ngx-stripe");
const app_service_1 = require("../../../commons/app.service");
const core_2 = require("@ngx-translate/core");
const AppBaseComponent_1 = require("../../../commons/AppBaseComponent");
const application_events_service_1 = require("../../../xs/services/events/application-events.service");
class PhotogramEstimatePriceDialog extends AppBaseComponent_1.AppBaseComponent {
    constructor(dialogRef, data, fourD, service, router, snackBar, dialog, activeRoute, translate, stripeService, fb, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.activeRoute = activeRoute;
        this.translate = translate;
        this.stripeService = stripeService;
        this.fb = fb;
        this.estimatedPrice = 0;
        this.megapixel = 20;
        this.doSparse = true;
    }
    ngAfterViewInit() {
    }
    calculatePrice() {
        try {
            this.estimatedPrice = 0;
            if (this.megapixel && this.noOfImages) {
                let price = 0;
                if (this.doMesh || (this.doOrtho && this.doDense && this.doMesh && this.doDEM) || (this.doDense && this.doOrtho && this.doMesh)) {
                    price = 10;
                }
                else if ((this.doDense && this.doOrtho) || (this.doDense && this.doDEM) || (this.doOrtho && this.doDEM) || (this.doDense && this.doDEM && this.doOrtho)) {
                    price = 5;
                }
                else if (this.doOrtho || this.doDEM || this.doDense) {
                    price = 5;
                }
                else if (this.doSparse) {
                    price = 3;
                }
                this.estimatedPrice = (this.megapixel * this.noOfImages / 1000 * price).toFixed(2);
                if (this.estimatedPrice < 25) {
                    this.estimatedPrice = 25;
                }
            }
        }
        catch (e) {
            this.estimatedPrice = 'Error';
        }
    }
}
exports.PhotogramEstimatePriceDialog = PhotogramEstimatePriceDialog;
